import {
    AlarmStateModel, SoundState
} from './state';
import {createAction} from '../../base/fsa';
import {IntercomModel} from '../../types/intercom';
import {ControlModel} from "../../types/control";

export const controlSendErrorAction = createAction(
    resolve => (controlId: string, hasError: boolean) => resolve({controlId, hasError}),
);

export const inputSendErrorAction = createAction(
    resolve => (inputId: string, hasError: boolean) => resolve({inputId, hasError}),
);

export const mediaStatusUpdatedAction = createAction(
    resolve => (status: string) => resolve(status),
);

export const setIntercomStatusAction = createAction(
    resolve => (status: string, is_incoming_call: boolean, id = '', name = '') => resolve({
        status,
        is_incoming_call,
        id,
        name,
    }),
);

export const setIntercomInfoAction = createAction(
    resolve => (info: IntercomModel) => resolve(info),
);

export const setBellStatusAction = createAction(
    resolve => (status: string) => resolve(status),
);

export const setScreenSaverStatusAction = createAction(
    resolve => (status: string) => resolve(status),
);

export const entityDeletedAction = createAction(
    resolve => (id: string, type: string) => resolve({id, type}),
);

export const setEntityListAction = createAction(
    resolve => (entities: unknown, type: string) => resolve({entities: entities || [], type}),
);

export const entityCreatedAction = createAction(
    resolve => (entity: unknown, type: string) => resolve({entity, type}),
);

export const entityUpdatedAction = createAction(
    resolve => (entity: { id: string, [key: string]: unknown }, type: string) => resolve({entity, type}),
);

export const setDefaultAlarmStateAction = createAction(
    resolve => (alarmStateModel: AlarmStateModel) => resolve(alarmStateModel),
);

export const setSoundStateAction = createAction(
    resolve => (soundState: SoundState) => resolve(soundState),
);

export const setGroupControlsAction = createAction(
    resolve => (groupControlList: ControlModel[]) => resolve(groupControlList),
);

export const setPasswordAction = createAction(
    resolve => (passwordStatus: boolean) => resolve(passwordStatus),
);
